import Container from "@components/Container/Container";

/**
 * Component to render Description of SIA on homepage
 */
const SIADescription = (): React.ReactElement => {
  return (
    <Container
      rootClassName="flex flex-row justify-center px-0"
      data-testid="sia-description-component"
    >
      <div className="mb-9 mt-6 flex w-full flex-col justify-center text-center text-gray-850 md:pl-1 md:pr-3 lg:w-10/12 lg:flex-row lg:px-0 lg:pl-2">
        <div className="w-full lg:w-4/12 lg:pr-5">
          <h2 className="leading-1 mb-2 px-3 text-left font-poppins text-4xl font-medium md:mb-6 lg:mb-0 lg:px-0 lg:text-8xl">
            {"Sustainability "}
            <br className="hidden lg:inline" />
            {"Impact Awards"}
          </h2>
        </div>

        <div className="text-md w-full px-3 text-left font-public-sans leading-7 md:px-0 md:pl-2 lg:w-8/12">
          <p>
            The Sustainability Impact Awards (SI Awards), launched on 1 February
            2023, is jointly presented by The Business Times and UOB, with the
            Centre for Governance and Sustainability (CGS) at the National
            University of Singapore Business School as the knowledge partner.
          </p>
        </div>
      </div>
    </Container>
  );
};

export default SIADescription;
